module.exports = __webpack_public_path__ + "static/pen-state-1-3d00d88e6dea097f915077d2f7533643.png";